import { CollectionsProfile } from "../CollectionsProfile";
import { Button, DataSource, HorizontalSpacer, Label, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutCollectionsProfileFilter extends Layout {
    buttonApply: Button;
    buttonCancel: Button;
    buttonReset: Button;
    horizontalspacer1: HorizontalSpacer;
    labelAdvancedFilter: Label;
    layoutProfile: CollectionsProfile;
    panelHeader: Panel;
    sourceCollectionsProfile: DataSource;
}
